// extracted by mini-css-extract-plugin
export default {"wp-textarea":"WpTextarea_wp-textarea__otxZC"};